// فقط UI تغییر کرده، منطق شما دست نخورده
import { useFormik } from "formik";
import Chip from "global/Chip/Chip";
import CustomPersonalizeForm from "global/CustomSwitchInput/CustomPersonalizeForm";
import { paginationType } from "global/Interfaces/Interfaces";
import SimpleButton from "global/SimpleButton/SimpleButton";
import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterSurvey, setFilterSurvey } from "redux/survey/survey";
import { QuestionFilterElements } from "./filters";

interface OptionType {
  id: number | string;
  text: string;
}
interface SurveySearchProps {
  options: {
    replyTypeSelect: OptionType[];
    questionTypeSelect: OptionType[];
    questionAssessmentMethodSelect: OptionType[];
  };
  isActive?: boolean;
}

const SurveySearch: FC<SurveySearchProps> = ({ options, isActive }) => {
  const [chipData, setChipData] = useState<any>("");
  const { pageNumbers } = useSelector((state: paginationType) => state.paginate);
  const [filterData, setFilterData] = useState<any>({});
  const dispatch = useDispatch();
  // const { surveyData, fetchpost, filter } = useSelector(
  //   (state: any) => state.SurveySlice
  // );


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      surveyType: null,
      questionType: null,
      replyType: null,
      // اگر فیلتر عنوان/تاریخ دارید اینجا هم اضافه کنید
      // title: "",
      // fromDate: null,
      // toDate: null
    },
    onSubmit: async (values: any) => {
      setFilterData(values);
      setChipData({ ...values, hubId: undefined });
    },
  });

  const { values, handleSubmit, handleReset }: any = formik;

  useEffect(() => {
    const finalData = {
      ...values,
      isActive: !isActive,
      surveyType: values.surveyType?.id,
      questionType: values.questionType?.id,
      replyType: values.replyType?.id,
    };

    dispatch(setFilterSurvey({ ...finalData }));
    dispatch(
      filterSurvey({
        ...finalData,
        pageSize: 10,
        pageNumber: pageNumbers,
      }) as any
    );
  }, [filterData, pageNumbers, dispatch]);

  return (
    <div className="w-full mt-5" dir="rtl">
      <div className="bg-[#EF5644]/5 border border-[#EF5644]/10 rounded-2xl overflow-hidden">
        {/* header */}
        <div className="flex items-center justify-between px-5 py-4 bg-white/70">
          <div className="flex items-center gap-2 text-gray-700 font-bold">
            <span className="text-[#EF5644]">🔎</span>
            فیلتر
          </div>

          <button
            type="button"
            onClick={() => {
              handleReset();
              setFilterData({});
              setChipData("");
            }}
            className="px-4 py-2 rounded-xl border border-[#EF5644]/20 text-[#EF5644] bg-white hover:bg-[#EF5644]/5 text-sm font-semibold transition"
          >
            حذف فیلتر
          </button>
        </div>

        {/* body */}
        <div className="px-5 py-5 bg-white">
          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-4 gap-4">
            {QuestionFilterElements.filter((item) => item.isMain).map(
              (item: any, index: number) => (
                <div key={index} className="w-full">
                  <CustomPersonalizeForm
                    element={item}
                    formik={formik}
                    selectOptions={{ ...options }}
                  />
                </div>
              )
            )}

            <div className="flex items-end">
              <SimpleButton searchBtn />
            </div>
          </form>

          {filterData && (
            <div className="mt-4">
              <Chip filterData={chipData} formData={formik} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SurveySearch;
